import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { RoleProductQuota } from '../models/entities/role-product-quota';
import { RoleProductQuotasRequest } from '../models/dtos/role-product-quotas-request';
import { RoleProductRate } from '../models/entities/role-product-rate';
import { RoleProductRatesRequest } from '../models/dtos/role-product-rates-request';
import { RoleTarget } from '../models/entities/role-target';
import { RoleTargetRequest } from '../models/dtos/role-target-request';
import { TargetTypeRequest } from '../models/dtos/target-type-request';
import { TargetType } from '../models/entities/target-type';
import { TargetProductFamily } from '../models/entities/target-product-family';

@Injectable({
  providedIn: 'root'
})


export class SalesAdminService {

  constructor(private networkService: LeanNetworkService,  public userService : UserService) { 
  }
  
  roleProductQuotasGet(roleCode : string, himSelf : boolean): Promise<RoleProductQuota[]> {
      let request: BaseRequest = new BaseRequest(this.userService.userInfo);
      request.code      = roleCode;
      request.blnArg1   = himSelf;
     
      return new Promise((resolve) => {
          this.networkService.post('sales/admin/roleProductQuotasGet', request).then(result => {
              return resolve(result.roleProductQuotas);   
          });
      });
  }


  roleProductQuotasSave(roleCode : string, roleProductQuotas : RoleProductQuota[]): Promise<RoleProductQuota[]> {
    let request: RoleProductQuotasRequest = new RoleProductQuotasRequest(this.userService.userInfo);
    request.code                = roleCode;
    request.roleProductQuotas   = roleProductQuotas;
   
    return new Promise((resolve) => {
        this.networkService.post('sales/admin/roleProductQuotasSave', request).then(result => {
            return resolve(result.roleProductQuotas);   
        });
    });
  }

  roleProductQuotasDispatch(roleCode : string): Promise<RoleProductQuota[]> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code                = roleCode;

    return new Promise((resolve) => {
        this.networkService.post('sales/admin/roleProductQuotasDispatch', request).then(result => {
            return resolve(result.roleProductQuotas);   
        });
    });
  }

  roleProductRatesGet(roleCode : string): Promise<RoleProductRate[]> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.code      = roleCode;
   
    return new Promise((resolve) => {
        this.networkService.post('sales/admin/roleProductRatesGet', request).then(result => {
            return resolve(result.roleProductRates);   
        });
    });
  }

  roleProductRatesSave(roleCode : string, roleProductRates : RoleProductRate[]): Promise<RoleProductRate[]> {
    let request: RoleProductRatesRequest = new RoleProductRatesRequest(this.userService.userInfo);
    request.code                = roleCode;
    request.roleProductRates   = roleProductRates;
   
    return new Promise((resolve) => {
        this.networkService.post('sales/admin/roleProductRatesSave', request).then(result => {
            return resolve(result.roleProductRates);   
        });
    });
  }


  roleTargetsGet(roleCode : string, periodCode : string, targetTypeCode : string, locked: boolean, unlocked : boolean, page : number): Promise<any> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1       = roleCode;
    request.strArg2       = periodCode;
    request.strArg3       = targetTypeCode;
    request.blnArg1       = locked;
    request.blnArg2       = unlocked;
    request.page          = page;
   
    return new Promise((resolve) => {
        this.networkService.post('sales/admin/roleTargetsGet', request).then(result => {
            return resolve(result);   
        });
    });
  }

  roleTargetSave(roleTarget : RoleTarget): Promise<RoleTarget> {
    let request: RoleTargetRequest = new RoleTargetRequest(this.userService.userInfo);
    request.roleTarget = roleTarget;

    return new Promise((resolve) => {
        this.networkService.post('sales/admin/roleTargetSave', request).then(result => {
            return resolve(result.roleTarget);   
        });
    });
  }

  roleTargetLockToggle(id : number): Promise<RoleTarget> {
    let request: RoleTargetRequest = new RoleTargetRequest(this.userService.userInfo);
    request.id = id;

    return new Promise((resolve) => {
        this.networkService.post('sales/admin/roleTargetLockToggle', request).then(result => {
            return resolve(result.roleTarget);   
        });
    });
  }

  targetTypesGet(code: string, name: string): Promise<TargetType[]> {
      let request: BaseRequest = new BaseRequest(this.userService.userInfo);
      request.strArg1       = code;
      request.strArg2       = name;
    
      return new Promise((resolve) => {
        this.networkService.post('sales/admin/targetTypesGet', request).then(result => {
            return resolve(result.targetTypes);   
        });
    });
  }

targetTypeSave(targetType : TargetType): Promise<TargetType> {
    let request: TargetTypeRequest = new TargetTypeRequest(this.userService.userInfo);
    request.targetType = targetType;

    return new Promise((resolve) => {
        this.networkService.post('sales/admin/targetTypeSave', request).then(result => {
            return resolve(result.targetType);   
        });
    });
  }
  

  
  targetProductFamilysGet(code: string, name: string): Promise<TargetProductFamily[]> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1       = code;
    request.strArg2       = name;
  
    return new Promise((resolve) => {
      this.networkService.post('sales/admin/targetProductFamilysGet', request).then(result => {
          return resolve(result.targetProductFamilys);   
      });
  });
}
}

